import {
  Box,
  Button,
  Checkbox,
  Chip,
  Container,
  Dialog,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Switch,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import {
  DateRange as DateRangeIcon,
  Delete as DeleteIcon,
  Description as DescriptionIcon,
  Visibility as VisibilityIcon,
  PictureAsPdf as PdfIcon,
  Image as ImageIcon,
  InsertDriveFile as FileIcon,
  Business as BusinessIcon,
  DirectionsCar as CarIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
} from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NitMasterAction } from "../../actions/NitMaster";
import { ImageUpload } from "../../actions/ImageUpload";
import { DeleteFileAction } from "../../actions/DeleteFile";
import { VendorAction } from "../../actions/vendor";
import { VehicleAction } from "../../actions/vehicle";
import useCommonStyles from "../CommonComponents/CommanStyle/indexStyle";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";
import LoadingComponent from "../CommonComponents/loadinComponent";
import TopView from "../CommonComponents/topView";
import moment from "moment";
import { Autocomplete } from "@material-ui/lab";
import useApiFetch from "../CommonComponents/CommonFetchApi/fetchAllDropdownListApi";

const useLocalStyles = makeStyles((theme) => ({
  statusChip: {
    borderRadius: 20,
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "0.75rem",
    letterSpacing: "0.05em",
    margin: "2px",
  },
  activeChip: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
  },
  inactiveChip: {
    background: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
    color: "white",
    boxShadow: "0 4px 12px rgba(107, 114, 128, 0.3)",
  },

  sectionContainer: {
    background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
    border: "1px solid rgba(102, 126, 234, 0.2)",
    borderRadius: "20px",
    padding: theme.spacing(3),
    margin: theme.spacing(3, 0),
    backdropFilter: "blur(10px)",
  },

  addButton: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "10px 24px",
    borderRadius: 12,
    fontWeight: 600,
    textTransform: "none",
    fontSize: "0.875rem",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(102, 126, 234, 0.3)",
    },
  },

  fileInput: {
    display: "none",
  },
  fileUploadButton: {
    border: "2px dashed rgba(102, 126, 234, 0.5)",
    borderRadius: 12,
    padding: theme.spacing(5),
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#667eea",
      background: "rgba(102, 126, 234, 0.05)",
    },
  },

  filePreviewContainer: {
    padding: theme.spacing(2),
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    background: "rgba(102, 126, 234, 0.05)",
    marginTop: theme.spacing(1),
  },

  filePreviewImage: {
    width: "100%",
    height: "200px",
    objectFit: "contain",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
  },

  fileInfoContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1),
  },

  fileIconContainer: {
    width: 60,
    height: 60,
    borderRadius: 8,
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #e5e7eb",
  },

  actionButton: {
    borderRadius: 12,
    margin: theme.spacing(0, 0.5),
    padding: 8,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    },
  },

  deleteButton: {
    color: "#ef4444",
    background: "rgba(239, 68, 68, 0.1)",
    "&:hover": {
      background: "rgba(239, 68, 68, 0.2)",
    },
  },

  viewButton: {
    color: "#3b82f6",
    background: "rgba(59, 130, 246, 0.1)",
    "&:hover": {
      background: "rgba(59, 130, 246, 0.2)",
    },
  },

  dialogImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
    objectFit: "contain",
  },

  supportedFormats: {
    fontSize: "0.75rem",
    color: "#6b7280",
    marginTop: theme.spacing(0.5),
  },

  uploadingProgress: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: "#667eea",
  },

  vendorModal: {
    "& .MuiDialog-paper": {
      borderRadius: 20,
      background: "rgba(255, 255, 255, 0.98)",
      backdropFilter: "blur(20px)",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
      border: "1px solid rgba(102, 126, 234, 0.2)",
    },
  },
  vendorModalTitle: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: 700,
    fontSize: "1.5rem",
    padding: theme.spacing(3),
    borderBottom: "1px solid rgba(102, 126, 234, 0.1)",
  },
  vendorModalContent: {
    padding: theme.spacing(3),
    backgroundColor: "white",
  },
}));

const validateNITData = (formData) => {
  let errors = {};

  const nitNumberPattern = /^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/;
  if (!formData.nitNumber || formData.nitNumber.trim() === "") {
    errors.nitNumber = "NIT Number is required";
  } else if (formData.nitNumber.trim().length < 3) {
    errors.nitNumber = "NIT Number must be at least 3 characters";
  } else if (formData.nitNumber.trim().length > 50) {
    errors.nitNumber = "NIT Number cannot exceed 50 characters";
  } else if (!nitNumberPattern.test(formData.nitNumber.trim())) {
    errors.nitNumber =
      "NIT Number can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
  }

  // if (!formData.expiryDate) {
  //   errors.expiryDate = "Expiry Date is required";
  // } else if (!formData.issueDate) {
  //   errors.issueDate = "Issue Date is required before setting Expiry Date";
  // } else if (new Date(formData.expiryDate) <= new Date(formData.issueDate)) {
  //   errors.expiryDate = "Expiry Date must be greater than Issue Date";
  // }

  if (!formData.typeOfContract) {
    errors.typeOfContract = "Type of Contract is required";
  }

  if (!formData.typeOfWork) {
    errors.typeOfWork = "Type of Work is required";
  }

  if (!formData.mineId) {
    errors.mineId = "Mine Name is required";
  }

  if (!formData.vendorId) {
    errors.vendorId = "Transporter Name is required";
  }

  // if (formData.cpdOrTpd) {
  //   const cpdValue = String(formData.cpdOrTpd).trim();
  //   if (!/^\d*\.?\d+$/.test(cpdValue)) {
  //     errors.cpdOrTpd = "Only numbers are allowed";
  //   } else {
  //     const numValue = Number(cpdValue);
  //     if (numValue <= 0) {
  //       errors.cpdOrTpd = "CPD/TPD must be greater than 0";
  //     } else if (numValue > 999999) {
  //       errors.cpdOrTpd = "CPD/TPD cannot exceed 999999";
  //     }
  //   }
  // }

  if (formData.cpdOrTpd) {
    const cpdValue = String(formData.cpdOrTpd).trim();
    if (!/^\d+$/.test(cpdValue)) {
      errors.cpdOrTpd = "Only whole numbers (integers) are allowed";
    } else {
      const numValue = Number(cpdValue);
      if (numValue <= 0) {
        errors.cpdOrTpd = "CPD/TPD must be greater than 0";
      } else if (numValue > 999999) {
        errors.cpdOrTpd = "CPD/TPD cannot exceed 999999";
      }
    }
  }

  if (formData.maximumLeadDistance) {
    const mldValue = String(formData.maximumLeadDistance).trim();
    if (!/^\d+$/.test(mldValue)) {
      errors.maximumLeadDistance = "Only whole numbers (integers) are allowed";
    } else {
      const numValue = Number(mldValue);
      if (numValue <= 0) {
        errors.maximumLeadDistance =
          "Maximum Lead Distance must be greater than 0";
      } else if (numValue > 999999) {
        errors.maximumLeadDistance =
          "Maximum Lead Distance cannot exceed 999999";
      }
    }
  }

  // if (!formData.issueDate) {
  //   errors.issueDate = "Issue Date is required";
  // }

  return errors;
};

const getFileIcon = (fileType) => {
  if (!fileType) {
    return <DescriptionIcon style={{ color: "#667eea", fontSize: 32 }} />;
  }

  if (fileType.startsWith("image/")) {
    return <ImageIcon style={{ color: "#667eea", fontSize: 32 }} />;
  } else if (fileType === "application/pdf") {
    return <PdfIcon style={{ color: "#ef4444", fontSize: 32 }} />;
  } else if (
    fileType === "application/vnd.ms-excel" ||
    fileType ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    return <FileIcon style={{ color: "#10b981", fontSize: 32 }} />;
  } else {
    return <DescriptionIcon style={{ color: "#667eea", fontSize: 32 }} />;
  }
};
const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export default function AddNIT() {
  const { fetchVendorList, fetchSiteList } = useApiFetch();

  const { showSnackbar } = useSnackbar();
  const classes = useCommonStyles();
  const localStyles = useLocalStyles();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [errors, setErrors] = useState({});
  const [openPreview, setOpenPreview] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteNitConfirmOpen, setDeleteNitConfirmOpen] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [CategoryWiseList, setCategoryWiseList] = useState({});
  const [openAddModal, setOpenAddModal] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const [typeMode, setTypeMode] = useState(""); // "contract" or "work"
  const [nitData, setNitData] = useState({
    nitNumber: "",
    expiryDate: "",
    isActive: true,
    file: null,
    fileUrl: "",
    fileName: "",
    typeOfContract: "",
    typeOfWork: "",
    issueDate: "",
    mineId: "",
    vendorId: "",
    mineName: "",
    vendorName: "",
    cpdOrTpd: "",
    maximumLeadDistance: "",
  });

  const [contractTypes, setContractTypes] = useState([]);
  const [workTypes, setWorkTypes] = useState([]);
  const [contractInput, setContractInput] = useState("");
  const [workInput, setWorkInput] = useState("");
  const [mineInput, setMineInput] = useState("");
  const [transporterInput, setTransporterInput] = useState("");
  const permissionAccess = JSON.parse(sessionStorage.getItem("data"));
  const [mineList, setMineList] = useState([]);
  const [transporterList, setTransporterList] = useState([]);
  const [selectedMine, setSelectedMine] = useState(null);
  const [selectedTransporter, setSelectedTransporter] = useState(null);
  const [areaInput, setAreaInput] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);

  // Add Vendor Modal states
  const [openVendorModal, setOpenVendorModal] = useState(false);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorErrors, setVendorErrors] = useState({});
  const [vendorFormData, setVendorFormData] = useState({
    name: "",
    officialName: "",
    email: "",
    vendorMobile: "",
    companyName: "",
    address: "",
  });
  const [modalVehicleList, setModalVehicleList] = useState([]);
  const [modalMultiVehicles, setModalMultiVehicles] = useState([]);

  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("data"));
    if (userData?.userType === "ADMIN") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, []);

  useEffect(() => {
    if (id && id !== "undefined") {
      setIsEditMode(true);
      fetchNitById(id);
    }
  }, [id]);

  useEffect(() => {
    fetchDropdowns();
  }, []);

  const fetchDropdowns = async () => {
    const contractRes = await NitMasterAction.getAllContractTypes(showSnackbar);
    const workRes = await NitMasterAction.getAllWorkTypes(showSnackbar);

    // ✅ FIX: handle direct array response
    const contractList = contractRes || [];
    const workList = workRes || [];

    setContractTypes(
      contractList.map((item) => ({
        label: item.name,
        value: item,
      })),
    );

    setWorkTypes(
      workList.map((item) => ({
        label: item.name,
        value: item,
      })),
    );
  };

  useEffect(() => {
    if (contractTypes.length && nitData.typeOfContract?.id) {
      const selectedContract = contractTypes.find(
        (opt) => opt.value.id === nitData.typeOfContract.id,
      );

      if (selectedContract) {
        setNitData((prev) => ({
          ...prev,
          typeOfContract: selectedContract.value,
        }));
      }
    }

    if (workTypes.length && nitData.typeOfWork?.id) {
      const selectedWork = workTypes.find(
        (opt) => opt.value.id === nitData.typeOfWork.id,
      );

      if (selectedWork) {
        setNitData((prev) => ({
          ...prev,
          typeOfWork: selectedWork.value,
        }));
      }
    }
  }, [contractTypes, workTypes]);
  useEffect(() => {
    if (nitData.typeOfContract?.name) {
      setContractInput(nitData.typeOfContract.name);
    }

    if (nitData.typeOfWork?.name) {
      setWorkInput(nitData.typeOfWork.name);
    }

    if (nitData.mineName && nitData.mineName !== "N/A") {
      setMineInput(nitData.mineName);
    }

    if (nitData.vendorName && nitData.vendorName !== "N/A") {
      setTransporterInput(nitData.vendorName);
    }
  }, [
    nitData.typeOfContract,
    nitData.typeOfWork,
    nitData.mineName,
    nitData.vendorName,
  ]);

  useEffect(() => {
    if (CategoryWiseList?.mineList) {
      setMineList(CategoryWiseList.mineList);
    }
    if (CategoryWiseList?.areaList) {
      setAreaList(CategoryWiseList.areaList);
    }
  }, [CategoryWiseList]);

  useEffect(() => {
    if (
      mineList.length > 0 &&
      areaList.length > 0 &&
      nitData.mineId &&
      !selectedArea
    ) {
      const currentMine = mineList.find((m) => m.id === nitData.mineId);
      if (currentMine && currentMine.parentSiteId) {
        const currentArea = areaList.find(
          (a) => a.id === currentMine.parentSiteId,
        );
        if (currentArea) {
          setSelectedArea(currentArea);
          setAreaInput(currentArea.name || "");
        }
      }
    }
  }, [mineList, areaList, nitData.mineId, selectedArea]);

  const getFilteredMines = () => {
    if (selectedArea && selectedArea.id) {
      return mineList.filter((mine) => mine.parentSiteId === selectedArea.id);
    }
    return mineList;
  };

  useEffect(() => {
    fetchSiteList(null, setCategoryWiseList);
    fetchVendorList(setVendorList);
  }, []);

  const fetchNitById = async (nitId) => {
    setLoading(true);
    const response = await NitMasterAction.getNitById2(nitId, showSnackbar);

    console.log("nitbyid", response);
    if (response && response.data) {
      const nit = response.data;
      const fileUrl = nit.doc;
      const fileName = getFileNameFromUrl(fileUrl);

      setNitData({
        nitNumber: nit.nitNumber || "",
        issueDate: nit.issueDate
          ? moment(nit.issueDate).format("YYYY-MM-DD")
          : "",
        expiryDate: nit.expiryDate
          ? moment(nit.expiryDate).format("YYYY-MM-DD")
          : "",

        isActive: nit.isActive,
        file: null,
        fileUrl: fileUrl,
        fileName: fileName,
        typeOfContract: nit.typeOfContract || null,
        typeOfWork: nit.typeOfWork || null,
        mineId: nit.mine.id || "",
        vendorId: nit.vendor.id || "",
        mineName: nit.mine.name || "N/A",
        vendorName: nit.vendor.name || "N/A",
        cpdOrTpd: nit.cpdOrTpd !== undefined ? nit.cpdOrTpd : "",
        maximumLeadDistance:
          nit.maximumLeadDistance !== undefined ? nit.maximumLeadDistance : "",
      });
    } else {
      showSnackbar("Failed to fetch NIT data", "error");
    }
    setLoading(false);
  };

  const nitPermisions = permissionAccess?.menuVisiblity?.find(
    (menu) => menu.name === "NIT_MASTER",
  );

  const validateFile = (file) => {
    const allowedImageTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    const allowedTypes = [...allowedImageTypes];

    if (!allowedTypes.includes(file?.type)) {
      return `File ${file?.name} is not a valid image type (jpg, png, gif, webp)`;
    }

    const fileSizeInMB = file?.size / (1024 * 1024);
    if (fileSizeInMB > 5) {
      return `File ${file?.name} size should be less than 5MB.`;
    }

    if (file?.name?.length > 100) {
      return `File ${file?.name} has a filename that is too long (max 100 characters).`;
    }

    if (file?.name?.includes("\u0000") || file?.name?.includes("%00")) {
      return `File ${file?.name} has an invalid filename (null bytes detected).`;
    }

    const metaCharRegex = /[\/\\:*?"<>|;%]/;
    if (metaCharRegex.test(file?.name)) {
      return `File ${file?.name} contains invalid characters in the filename.`;
    }

    const nameParts = file?.name?.split(".");
    if (nameParts?.length > 2) {
      return `File ${file?.name} has a double extension which is not allowed.`;
    }

    return null;
  };

  const onFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const fileError = validateFile(selectedFile);
    if (fileError) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        file: fileError,
      }));
      showSnackbar(fileError, "error");
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      file: "",
    }));

    setNitData((prev) => ({
      ...prev,
      file: selectedFile,
    }));

    await uploadFile(selectedFile);

    event.target.value = "";
  };

  const uploadFile = async (file) => {
    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("files", file);
      formData.append("token", "MCL");

      const uploadResponse = await ImageUpload.fetchImageUpload(formData);
      console.log("uploadResponse", uploadResponse);

      if (uploadResponse != null && uploadResponse.data?.fileUrls?.length > 0) {
        const fileUrl = uploadResponse.data.fileUrls[0];
        const fileName = fileUrl.split("=")[1] || "";

        setNitData((prev) => ({
          ...prev,
          fileUrl: fileUrl,
          fileName: fileName,
        }));

        showSnackbar("File uploaded successfully", "success");
      } else {
        showSnackbar(
          uploadResponse?.message || "Failed to upload file",
          "error",
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      showSnackbar("Failed to upload file. Please try again.", "error");
      setNitData((prev) => ({
        ...prev,
        file: null,
        fileUrl: "",
        fileName: "",
      }));
    } finally {
      setIsUploading(false);
    }
  };

  const openFileSelector = () => {
    document.getElementById("nitFile").click();
  };

  const removeFile = async () => {
    setDeleteConfirmOpen(false);
    console.log("yashnitData", nitData);
    if (nitData.fileName) {
      try {
        await DeleteFileAction.deleteFile(
          {
            fileName: nitData.fileName,
            type: "nit",
          },
          showSnackbar,
        );
        showSnackbar("File removed successfully", "success");
      } catch (error) {
        console.error("Error deleting file:", error);
        showSnackbar("Failed to delete file from server", "error");
      }
    }

    setNitData((prev) => ({
      ...prev,
      file: null,
      fileUrl: "",
      fileName: "",
    }));
  };

  const handleOpenPreview = () => {
    if (!nitData.fileUrl) {
      showSnackbar("No document available to preview", "error");
      return;
    }

    if (!nitData.file) {
      const fileType = getFileTypeFromUrl(nitData.fileUrl);
      if (fileType?.startsWith("image/")) {
        setOpenPreview(true);
      } else {
        window.open(nitData.fileUrl, "_blank");
      }
    } else {
      if (nitData.file.type.startsWith("image/")) {
        setOpenPreview(true);
      } else {
        window.open(nitData.fileUrl, "_blank");
      }
    }
  };
  const handleClosePreview = () => setOpenPreview(false);

  const handleSubmit = async () => {
    const validationErrors = validateNITData(nitData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      showSnackbar(
        "Please fix the validation errors before submitting",
        "error",
      );
      return;
    }

    if (nitData.file && !nitData.fileUrl) {
      showSnackbar("Please wait for file upload to complete", "error");
      return;
    }

    setLoading(true);
    const userData = JSON.parse(sessionStorage.getItem("data"));

    try {
      const nitPayload = {
        nitNumber: nitData.nitNumber,
        issueDate: nitData.issueDate,
        expiryDate: nitData.expiryDate,
        isActive: nitData.isActive,
        // createdBy: userData.id,
        doc: nitData.fileUrl,
        typeOfContract: nitData.typeOfContract,
        typeOfWork: nitData.typeOfWork,
        mineId: nitData.mineId,
        vendorId: nitData.vendorId,
        mineName: nitData.mineName,
        vendorName: nitData.vendorName,
        cpdOrTpd: nitData.cpdOrTpd ? Number(nitData.cpdOrTpd) : "",
        maximumLeadDistance: nitData.maximumLeadDistance
          ? Number(nitData.maximumLeadDistance)
          : "",
      };
      console.log("nitpayload", nitPayload);
      let response;
      if (isEditMode) {
        response = await NitMasterAction.updateNit(
          id,
          nitPayload,
          showSnackbar,
        );
        console.log("updatenit", response);
      } else {
        response = await NitMasterAction.createNit(nitPayload, showSnackbar);
        console.log("addnit", response);
      }

      console.log("yash");

      if (response != null) {
        if (response.responseCode === 201) {
          showSnackbar("NIT created successfully", "success");

          setNitData({
            nitNumber: "",
            expiryDate: "",
            isActive: true,
            file: null,
            fileUrl: "",
            fileName: "",
            typeOfContract: "",
            typeOfWork: "",
            issueDate: "",
            mineId: "",
            vendorId: "",
            mineName: "",
            vendorName: "",
            cpdOrTpd: "",
            maximumLeadDistance: "",
          });

          setErrors({});

          navigate("/NitMaster");
        } else if (response.responseCode === 200) {
          showSnackbar("NIT updated successfully", "success");
          navigate("/NitMaster");
        } else {
          showSnackbar(response.message || "Failed to create NIT", "error");
        }
      } else {
        showSnackbar("Failed to create/ update  NIT", "error");
      }
    } catch (error) {
      console.error("Error in NIT creation:", error);
      showSnackbar("An error occurred while creating NIT", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNit = () => {
    setDeleteNitConfirmOpen(true);
  };

  const confirmDeleteNit = async () => {
    setDeleteNitConfirmOpen(false);
    setLoading(true);
    try {
      const response = await NitMasterAction.deleteNit(id, showSnackbar);
      if (response != null) {
        navigate("/NitMaster");
      }
    } catch (error) {
      showSnackbar("An error occurred while deleting NIT", "error");
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    navigate("/NitMaster");
  };

  const topViewData = {
    title: "Add NIT",
    subTitleFirst: "Dashboard >",
    subTitleSecond: "NIT Management >",
    subTitleThird: isEditMode ? "Edit NIT" : "Add NIT",
    buttonIcon: false,
    backPath: "/dashboard",
    backPathSecond: "/NitMaster",
    addButton: !isEditMode,
    addCancelClick: goBack,
    addClick: handleSubmit,
    updateClick: handleSubmit,
    goBackEditClick: goBack,
    updatePermission: nitPermisions?.updatePermission,
    updateButton: isEditMode,
    addButtonPermission: nitPermisions?.addPermission,
    addPermission: nitPermisions?.addPermission,
    deleteButton: isEditMode && isAdmin,
    deletePermission: isEditMode && isAdmin,
    deleteClick: handleDeleteNit,
  };

  const handleChange = (field, value) => {
    if (field === "nitNumber") {
      // No longer blocking input; validation happens on submit
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));

    setNitData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddType = async () => {
    if (!newTypeName.trim()) return;

    const payload = {
      id: null,
      name: newTypeName,
    };

    let res;

    if (typeMode === "contract") {
      res = await NitMasterAction.createContractType(payload, showSnackbar);
    } else {
      res = await NitMasterAction.createWorkType(payload, showSnackbar);
    }

    if (res) {
      showSnackbar("Added successfully", "success");

      setOpenAddModal(false);
      setNewTypeName("");

      await fetchDropdowns();

      // auto select
      setNitData((prev) => ({
        ...prev,
        [typeMode === "contract" ? "typeOfContract" : "typeOfWork"]: res,
      }));
    }
  };

  // ---- Add Vendor Modal Handlers ----
  const handleVendorFormChange = (field, value) => {
    // Clear the error for this field so user is not blocked while typing
    setVendorErrors((prev) => ({ ...prev, [field]: "" }));

    // For mobile, only allow digits and cap at 10
    if (field === "vendorMobile") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length <= 10) {
        setVendorFormData((prev) => ({ ...prev, [field]: numericValue }));
      }
      return;
    }

    // For all other fields, allow free typing
    setVendorFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateVendorForm = () => {
    let errs = {};
    const allowedPattern = /^[a-zA-Z0-9\s@%&_\-,\.\(\)]+$/;

    // Name validation
    if (!vendorFormData.name || vendorFormData.name.trim() === "") {
      errs.name = "Transporter Name is required";
    } else if (vendorFormData.name.trim().length < 3) {
      errs.name = "Transporter Name must be at least 3 characters";
    } else if (!allowedPattern.test(vendorFormData.name.trim())) {
      errs.name =
        "Name can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
    } else if (/^\d+$/.test(vendorFormData.name.trim())) {
      errs.name = "Name cannot be numbers only";
    }

    // Official name validation
    if (
      !vendorFormData.officialName ||
      vendorFormData.officialName.trim() === ""
    ) {
      errs.officialName = "Official Name is required";
    } else if (vendorFormData.officialName.trim().length < 3) {
      errs.officialName = "Official Name must be at least 3 characters";
    } else if (!allowedPattern.test(vendorFormData.officialName.trim())) {
      errs.officialName =
        "Official Name can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
    } else if (/^\d+$/.test(vendorFormData.officialName.trim())) {
      errs.officialName = "Official Name cannot be numbers only";
    }

    // Email validation
    if (!vendorFormData.email || vendorFormData.email.trim() === "") {
      errs.email = "Email is required";
    } else if (!allowedPattern.test(vendorFormData.email.trim())) {
      errs.email =
        "Email can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        vendorFormData.email.trim(),
      )
    ) {
      errs.email = "Please enter a valid email address";
    }

    // Mobile number validation
    if (
      !vendorFormData.vendorMobile ||
      vendorFormData.vendorMobile.trim() === ""
    ) {
      errs.vendorMobile = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(vendorFormData.vendorMobile.trim())) {
      errs.vendorMobile = "Mobile Number must be exactly 10 digits";
    }

    // Company name validation
    if (
      !vendorFormData.companyName ||
      vendorFormData.companyName.trim() === ""
    ) {
      errs.companyName = "Company Name is required";
    } else if (vendorFormData.companyName.trim().length < 3) {
      errs.companyName = "Company Name must be at least 3 characters";
    } else if (!allowedPattern.test(vendorFormData.companyName.trim())) {
      errs.companyName =
        "Company Name can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
    } else if (/^\d+$/.test(vendorFormData.companyName.trim())) {
      errs.companyName = "Company Name cannot be numbers only";
    }

    // Address validation
    if (!vendorFormData.address || vendorFormData.address.trim() === "") {
      errs.address = "Address is required";
    } else if (vendorFormData.address.trim().length < 10) {
      errs.address = "Address must be at least 10 characters";
    } else if (!allowedPattern.test(vendorFormData.address.trim())) {
      errs.address =
        "Address can only contain letters, numbers, spaces, and @ % & _ - , . ( )";
    } else if (/^\d+$/.test(vendorFormData.address.trim())) {
      errs.address = "Address cannot be numbers only";
    }

    return errs;
  };

  const fetchModalVehicleList = () => {
    let sideIds = [];
    const userData = JSON.parse(sessionStorage.getItem("data"));
    if (userData?.sites?.length > 0) {
      userData.sites.forEach((element) => {
        sideIds.push(element.id);
      });
    }

    VehicleAction.fetchVehicleList2(
      {
        pageNo: 0,
        pageSize: 100,
        companyId: userData.companyId,
        number: "",
        vehicleType: "",
        driver: "",
        siteIds: sideIds,
        userId: userData.id,
        allVehicle: true,
        forDropDown: true,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        setModalVehicleList(response?.data || []);
      } else {
        setModalVehicleList([]);
      }
    });
  };

  const handleVendorModalOpen = () => {
    setOpenVendorModal(true);
    fetchModalVehicleList();
  };

  const handleVendorModalClose = () => {
    setOpenVendorModal(false);
    setVendorErrors({});
    setVendorFormData({
      name: "",
      officialName: "",
      email: "",
      vendorMobile: "",
      companyName: "",
      address: "",
    });
    setModalMultiVehicles([]);
  };

  const handleVendorSubmit = async () => {
    const validationErrors = validateVendorForm();
    setVendorErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      showSnackbar("Please fix the validation errors", "error");
      return;
    }

    setVendorLoading(true);
    const userData = JSON.parse(sessionStorage.getItem("data"));
    let data = new FormData();
    data.append("name", vendorFormData.name);
    data.append("officialName", vendorFormData.officialName);
    data.append("email", vendorFormData.email);
    data.append("phoneNumber", vendorFormData.vendorMobile);
    data.append("address", vendorFormData.address);
    data.append("companyName", vendorFormData.companyName);
    data.append("companyId", userData.companyId);
    data.append("createdBy", userData.id);

    // Append selected vehicles
    modalMultiVehicles.forEach((element, index) => {
      data.append(`vehicles[${index}].id`, element.id);
    });

    try {
      const response = await VendorAction.saveUser(data, showSnackbar);
      if (response != null) {
        showSnackbar("Transporter Created Successfully", "success");
        handleVendorModalClose();
        // Refresh the vendor list so the new vendor appears in the dropdown
        await fetchVendorList(setVendorList);
      }
    } catch (error) {
      console.error("Error creating vendor:", error);
      showSnackbar("Failed to create transporter", "error");
    } finally {
      setVendorLoading(false);
    }
  };

  const getFileTypeFromUrl = (url) => {
    if (!url) return null;

    const extension = url.split(".").pop().toLowerCase().split("?")[0];

    switch (extension) {
      case "pdf":
        return "application/pdf";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "png":
        return "image/png";
      case "gif":
        return "image/gif";
      case "xls":
        return "application/vnd.ms-excel";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      default:
        return null;
    }
  };

  const getFileNameFromUrl = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    const fileName = parts[parts.length - 1];
    return fileName.split("?")[0];
  };

  console.log("yash", CategoryWiseList);

  return (
    <div className="makeStylesRoot">
      <LoadingComponent isLoading={isLoading} />

      <Dialog
        open={openPreview}
        onClose={handleClosePreview}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          {nitData.fileUrl &&
          getFileTypeFromUrl(nitData.fileUrl)?.startsWith("image/") ? (
            <img
              src={nitData.fileUrl}
              alt="Document Preview"
              className={localStyles.dialogImage}
              style={{ maxHeight: "70vh" }}
            />
          ) : (
            <Box textAlign="center" p={3}>
              <Typography variant="h6">Preview not available</Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginTop: 8 }}
              >
                This file type cannot be previewed in the dialog.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePreview} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          style={{
            backgroundColor: "#003a6b",
          }}
        >
          <Typography style={{ color: "white" }}>Confirm Delete</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete the image?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={removeFile} color="secondary" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteNitConfirmOpen}
        onClose={() => setDeleteNitConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          style={{
            backgroundColor: "#003a6b",
          }}
        >
          <Typography style={{ color: "white" }}>Confirm Delete NIT</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this NIT?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteNitConfirmOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteNit}
            color="secondary"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Container>
        <TopView data={topViewData} />

        <Paper className={classes.mainCard}>
          <div className={classes.formSection}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3}>
                <div style={{ marginBottom: 0 }}>
                  <Typography className={classes.label}>
                    NIT Number <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    className={classes.modernTextField}
                    fullWidth
                    id="nitNumber"
                    type="text"
                    variant="outlined"
                    placeholder="Enter NIT Number Example (NIT-123%)"
                    value={nitData.nitNumber}
                    error={!!errors.nitNumber}
                    helperText={errors.nitNumber || ""}
                    onChange={(event) =>
                      handleChange("nitNumber", event.target.value)
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div style={{ marginBottom: 0 }}>
                  <Typography className={classes.label}>
                    Date of commencement
                  </Typography>
                  <TextField
                    className={classes.modernTextField}
                    fullWidth
                    type="date"
                    variant="outlined"
                    value={nitData.issueDate}
                    error={!!errors.issueDate}
                    helperText={errors.issueDate}
                    onChange={(event) =>
                      handleChange("issueDate", event.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div style={{ marginBottom: 0 }}>
                  <Typography className={classes.label}>
                    Date of Completion
                  </Typography>
                  <TextField
                    className={classes.modernTextField}
                    fullWidth
                    type="date"
                    variant="outlined"
                    value={nitData.expiryDate}
                    error={!!errors.expiryDate}
                    helperText={errors.expiryDate}
                    onChange={(event) =>
                      handleChange("expiryDate", event.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        min: nitData.issueDate || undefined, // Set min date to issue date if available
                      },
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>
                  Type of Contract <span style={{ color: "red" }}>*</span>
                </Typography>

                <div style={{ position: "relative" }}>
                  <Autocomplete
                    id="type-of-contract-autocomplete"
                    options={contractTypes || []}
                    getOptionLabel={(option) => option.label || ""}
                    className={classes.modernAutocomplete}
                    value={
                      contractTypes.find(
                        (option) => option.value === nitData.typeOfContract,
                      ) || null
                    }
                    inputValue={contractInput} // 🔥 controlled input
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === "input") {
                        setContractInput(newInputValue);
                      }
                    }}
                    disablePortal
                    onChange={(event, newValue) => {
                      handleChange("typeOfContract", newValue?.value || null);

                      // 🔥 IMPORTANT: update input text
                      setContractInput(newValue?.label || "");
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Type of Contract"
                        error={!!errors.typeOfContract}
                        helperText={errors.typeOfContract || ""}
                      />
                    )}
                  />

                  {/* 🔥 Add Button */}
                  {/* <IconButton
                    size="small"
                    onClick={async () => {
                      if (!contractInput.trim()) {
                        showSnackbar("Please type something first", "error");
                        return;
                      }

                      const payload = {
                        id: null,
                        name: contractInput,
                      };

                      const res = await NitMasterAction.createContractType(
                        payload,
                        showSnackbar,
                      );

                      if (res) {
                        await fetchDropdowns();

                        const selected = contractTypes.find(
                          (opt) => opt.value.name === contractInput,
                        );

                        setNitData((prev) => ({
                          ...prev,
                          typeOfContract: selected?.value || res,
                        }));

                        setContractInput(""); // ✅ clear input
                        showSnackbar("Added successfully", "success");
                      }
                    }}
                    style={{
                      position: "absolute",
                      right: "-10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "#fff",
                      border: "1px solid #ccc",
                      zIndex: 2,
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton> */}
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>
                  Type of Work <span style={{ color: "red" }}>*</span>
                </Typography>

                <div style={{ position: "relative" }}>
                  <Autocomplete
                    id="type-of-work-autocomplete"
                    options={workTypes || []}
                    getOptionLabel={(option) => option.label || ""}
                    className={classes.modernAutocomplete}
                    value={
                      workTypes.find(
                        (option) => option.value === nitData.typeOfWork,
                      ) || null
                    }
                    inputValue={workInput} // 🔥 controlled input
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === "input") {
                        setWorkInput(newInputValue);
                      }
                    }}
                    disablePortal
                    onChange={(event, newValue) => {
                      handleChange("typeOfWork", newValue?.value || null);

                      // 🔥 sync input
                      setWorkInput(newValue?.label || "");
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Type of Work"
                        error={!!errors.typeOfWork}
                        helperText={errors.typeOfWork || ""}
                      />
                    )}
                  />

                  {/* 🔥 Add Button */}
                  {/* <IconButton
                    size="small"
                    onClick={async () => {
                      if (!workInput.trim()) {
                        showSnackbar("Please type something first", "error");
                        return;
                      }

                      const payload = {
                        id: null,
                        name: workInput,
                      };

                      const res = await NitMasterAction.createWorkType(
                        payload,
                        showSnackbar,
                      );

                      if (res) {
                        await fetchDropdowns();

                        const selected = workTypes.find(
                          (opt) => opt.value.name === workInput,
                        );

                        setNitData((prev) => ({
                          ...prev,
                          typeOfWork: selected?.value || res,
                        }));

                        setWorkInput(""); // ✅ clear input
                        showSnackbar("Added successfully", "success");
                      }
                    }}
                    style={{
                      position: "absolute",
                      right: "-10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "#fff",
                      border: "1px solid #ccc",
                      zIndex: 2,
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton> */}
                </div>
              </Grid>{" "}
              {/* <Grid item xs={12} md={3}>
                <Typography className={classes.label}>Area Name</Typography>

                <Autocomplete
                  id="area-name-autocomplete"
                  options={areaList || []}
                  getOptionLabel={(option) => option.name || ""}
                  className={classes.modernAutocomplete}
                  value={selectedArea}
                  inputValue={areaInput}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      setAreaInput(newInputValue);
                    }
                  }}
                  disablePortal
                  onChange={(event, newValue) => {
                    setSelectedArea(newValue);
                    setAreaInput(newValue?.name || "");

                    // If a mine is currently selected and does not belong to the selected area, or if area is cleared, clear it.
                    if (!newValue) {
                      handleChange("mineId", "");
                      handleChange("mineName", "");
                      setMineInput("");
                    } else if (newValue.id) {
                      const currentMine = mineList.find(
                        (m) => m.id === nitData.mineId,
                      );
                      if (
                        currentMine &&
                        currentMine.parentSiteId !== newValue.id
                      ) {
                        handleChange("mineId", "");
                        handleChange("mineName", "");
                        setMineInput("");
                      }
                    }
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Area Name"
                    />
                  )}
                />
              </Grid> */}
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>
                  Mine Name <span style={{ color: "red" }}>*</span>
                </Typography>

                <Autocomplete
                  id="mine-name-autocomplete"
                  options={getFilteredMines()}
                  getOptionLabel={(option) => option.name || ""}
                  className={classes.modernAutocomplete}
                  value={
                    mineList.find((option) => option.id === nitData.mineId) ||
                    (nitData.mineId
                      ? { id: nitData.mineId, name: nitData.mineName }
                      : null)
                  }
                  inputValue={mineInput}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      setMineInput(newInputValue);
                    }
                  }}
                  disablePortal
                  onChange={(event, newValue) => {
                    handleChange("mineId", newValue?.id || "");
                    handleChange("mineName", newValue?.name || "");
                    setMineInput(newValue?.name || "");

                    // Automatically select Area if mine is selected
                    if (newValue && newValue.parentSiteId) {
                      const matchedArea = areaList.find(
                        (a) => a.id === newValue.parentSiteId,
                      );
                      if (matchedArea) {
                        setSelectedArea(matchedArea);
                        setAreaInput(matchedArea.name || "");
                      }
                    }
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Mine Name"
                      error={!!errors.mineId}
                      helperText={errors.mineId || ""}
                    />
                  )}
                />
              </Grid>{" "}
              <Grid item xs={12} md={3}>
                <Typography className={classes.label}>
                  Transporter Name <span style={{ color: "red" }}>*</span>
                </Typography>

                <div style={{ position: "relative" }}>
                  <Autocomplete
                    id="transporter-name-autocomplete"
                    options={vendorList || []}
                    getOptionLabel={(option) => option.name || ""}
                    className={classes.modernAutocomplete}
                    value={
                      vendorList.find(
                        (option) => option.id === nitData.vendorId,
                      ) ||
                      (nitData.vendorId
                        ? { id: nitData.vendorId, name: nitData.vendorName }
                        : null)
                    }
                    inputValue={transporterInput}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === "input") {
                        setTransporterInput(newInputValue);
                      }
                    }}
                    disablePortal
                    onChange={(event, newValue) => {
                      handleChange("vendorId", newValue?.id || "");
                      handleChange("vendorName", newValue?.name || "");
                      setTransporterInput(newValue?.name || "");
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Transporter"
                        error={!!errors.vendorId}
                        helperText={errors.vendorId || ""}
                      />
                    )}
                  />

                  {/* Add Transporter Button */}
                  <IconButton
                    size="small"
                    onClick={handleVendorModalOpen}
                    style={{
                      position: "absolute",
                      right: "-10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "#fff",
                      border: "1px solid #ccc",
                      zIndex: 2,
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div style={{ marginBottom: 24 }}>
                  <Typography className={classes.label}>CPD/TPD</Typography>
                  <TextField
                    className={classes.modernTextField}
                    fullWidth
                    id="cpdOrTpd"
                    type="number"
                    variant="outlined"
                    placeholder="Enter CPD/TPD Number Example (1234)"
                    value={nitData.cpdOrTpd}
                    error={!!errors.cpdOrTpd}
                    helperText={errors.cpdOrTpd || ""}
                    onChange={(event) =>
                      handleChange("cpdOrTpd", event.target.value)
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div style={{ marginBottom: 24 }}>
                  <Typography className={classes.label}>
                    Maximum Lead Distance
                  </Typography>
                  <TextField
                    className={classes.modernTextField}
                    fullWidth
                    id="maximumLeadDistance"
                    type="number"
                    variant="outlined"
                    placeholder="Enter Maximum Lead Distance"
                    value={nitData.maximumLeadDistance}
                    error={!!errors.maximumLeadDistance}
                    helperText={errors.maximumLeadDistance || ""}
                    onChange={(event) =>
                      handleChange("maximumLeadDistance", event.target.value)
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  className="ml-2 pt-1"
                  gutterBottom
                  variant="h6"
                  style={{ marginTop: "30px" }}
                >
                  <span
                    className="fontbold"
                    style={{
                      color: nitData.isActive ? "green" : "red",
                      minWidth: "80px",
                    }}
                  >
                    {nitData.isActive ? "Active" : "Inactive"}
                  </span>
                  <span className="ml-2 greyfirstheading font14">
                    <Switch
                      // disabled={isEditMode}
                      style={{
                        color: nitData.isActive ? "green" : "red",
                      }}
                      checked={nitData.isActive}
                      onChange={(event) =>
                        handleChange("isActive", event.target.checked)
                      }
                      color="secondary" // Default color for the active state
                      inputProps={{
                        "aria-label": "Disengaged Toggle",
                      }}
                    />
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div style={{ marginBottom: 24 }}>
                  <Typography className={classes.label}>
                    <DescriptionIcon
                      color="primary"
                      style={{ marginRight: 8 }}
                    />
                    Document
                  </Typography>

                  {!isEditMode && (
                    <Typography
                      variant="caption"
                      className={localStyles.supportedFormats}
                    >
                      Supported formats: JPG, JPEG, PNG, | Max size: 5MB
                    </Typography>
                  )}

                  <input
                    disabled={isEditMode}
                    type="file"
                    id="nitFile"
                    className={localStyles.fileInput}
                    onChange={onFileChange}
                    accept=".jpg,.jpeg,.png,.gif,.webp,image/jpeg,image/jpg,image/png,image/gif,image/webp"
                  />

                  {!nitData.fileUrl && !isEditMode ? (
                    <div
                      className={localStyles.fileUploadButton}
                      onClick={openFileSelector}
                    >
                      <Typography variant="body2" style={{ color: "#667eea" }}>
                        Click to upload document
                      </Typography>
                    </div>
                  ) : nitData.fileUrl ? (
                    <Box className={localStyles.filePreviewContainer}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className={localStyles.fileInfoContainer}>
                          <div className={localStyles.fileIconContainer}>
                            {getFileIcon(
                              nitData.file?.type ||
                                getFileTypeFromUrl(nitData.fileUrl),
                            )}
                          </div>
                          <div>
                            <Typography
                              variant="body2"
                              style={{ color: "#374151", fontWeight: 500 }}
                            >
                              {nitData.fileName ||
                                getFileNameFromUrl(nitData.fileUrl) ||
                                "Document"}
                            </Typography>
                            {nitData.file?.size && (
                              <Typography
                                variant="caption"
                                style={{ color: "#6b7280" }}
                              >
                                {formatFileSize(nitData.file.size)}
                              </Typography>
                            )}
                            {!isEditMode && isUploading && (
                              <div className={localStyles.uploadingProgress}>
                                <CircularProgress size={16} />
                                <Typography variant="caption">
                                  Uploading...
                                </Typography>
                              </div>
                            )}
                            {nitData.fileUrl && !isUploading && (
                              <Typography
                                variant="caption"
                                style={{ color: "#10b981", fontWeight: 500 }}
                              >
                                ✓ Uploaded
                              </Typography>
                            )}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: 8 }}>
                          {nitData.fileUrl && (
                            <IconButton
                              size="small"
                              onClick={handleOpenPreview}
                              className={`${localStyles.actionButton} ${localStyles.viewButton}`}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          )}
                          {!isEditMode && ( // Only show delete button in add mode
                            <IconButton
                              size="small"
                              onClick={() => setDeleteConfirmOpen(true)}
                              className={`${localStyles.actionButton} ${localStyles.deleteButton}`}
                              disabled={isUploading}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          )}
                        </div>
                      </div>

                      {nitData.fileUrl &&
                        getFileTypeFromUrl(nitData.fileUrl)?.startsWith(
                          "image/",
                        ) && (
                          <Box mt={2}>
                            <img
                              src={nitData.fileUrl}
                              alt="Preview"
                              className={localStyles.filePreviewImage}
                              onClick={handleOpenPreview}
                              style={{ cursor: "pointer" }}
                            />
                          </Box>
                        )}
                    </Box>
                  ) : isEditMode ? (
                    <Box
                      className={localStyles.filePreviewContainer}
                      style={{ opacity: 0.7 }}
                    >
                      <Typography
                        variant="body2"
                        style={{ color: "#6b7280", textAlign: "center" }}
                      >
                        No document attached
                      </Typography>
                    </Box>
                  ) : null}

                  {/* {errors.file && (
                    <Typography variant="caption" color="error">
                      {errors.file}
                    </Typography>
                  )} */}
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Container>

      {/* Add Transporter Modal */}
      <Dialog
        open={openVendorModal}
        onClose={handleVendorModalClose}
        maxWidth="lg"
        fullWidth
        className={localStyles.vendorModal}
      >
        <DialogTitle className={localStyles.vendorModalTitle}>
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center" }}
          >
            Add New Transporter
          </Typography>
        </DialogTitle>

        <DialogContent className={localStyles.vendorModalContent}>
          <Grid container spacing={3} style={{ marginTop: 8 }}>
            <Grid item xs={4}>
              <div style={{ marginBottom: 20 }}>
                <Typography className={classes.label}>
                  <PersonIcon color="primary" />
                  Transporter Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className={classes.modernTextField}
                  fullWidth
                  id="vendor-modal-name"
                  type="text"
                  variant="outlined"
                  placeholder="Enter Name"
                  value={vendorFormData.name}
                  error={!!vendorErrors.name}
                  helperText={vendorErrors.name || ""}
                  onChange={(e) =>
                    handleVendorFormChange("name", e.target.value)
                  }
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <Typography className={classes.label}>
                  <BusinessIcon color="primary" />
                  Transporter Company Name{" "}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className={classes.modernTextField}
                  fullWidth
                  id="vendor-modal-companyName"
                  type="text"
                  variant="outlined"
                  placeholder="Enter Company Name"
                  value={vendorFormData.companyName}
                  error={!!vendorErrors.companyName}
                  helperText={vendorErrors.companyName || ""}
                  onChange={(e) =>
                    handleVendorFormChange("companyName", e.target.value)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={4}>
              <div style={{ marginBottom: 20 }}>
                <Typography className={classes.label}>
                  <PhoneIcon color="primary" />
                  Transporter Mobile Number{" "}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className={classes.modernTextField}
                  fullWidth
                  id="vendor-modal-vendorMobile"
                  type="text"
                  variant="outlined"
                  placeholder="Enter Mobile Number"
                  value={vendorFormData.vendorMobile}
                  error={!!vendorErrors.vendorMobile}
                  helperText={vendorErrors.vendorMobile || ""}
                  inputProps={{ maxLength: 10 }}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, "");
                    if (numericValue.length <= 10) {
                      handleVendorFormChange("vendorMobile", numericValue);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <Typography
                        style={{
                          marginRight: 8,
                          fontWeight: 500,
                        }}
                      >
                        +91
                      </Typography>
                    ),
                  }}
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <Typography className={classes.label}>
                  <LocationIcon color="primary" />
                  Transporter Address <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className={classes.modernTextField}
                  fullWidth
                  id="vendor-modal-address"
                  type="text"
                  variant="outlined"
                  placeholder="Enter Address"
                  value={vendorFormData.address}
                  error={!!vendorErrors.address}
                  helperText={vendorErrors.address || ""}
                  onChange={(e) =>
                    handleVendorFormChange("address", e.target.value)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={4}>
              <div style={{ marginBottom: 20 }}>
                <Typography className={classes.label}>
                  <EmailIcon color="primary" />
                  Transporter Email ID <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className={classes.modernTextField}
                  fullWidth
                  id="vendor-modal-email"
                  type="email"
                  variant="outlined"
                  placeholder="Enter Email"
                  value={vendorFormData.email}
                  error={!!vendorErrors.email}
                  helperText={vendorErrors.email || ""}
                  onChange={(e) =>
                    handleVendorFormChange("email", e.target.value)
                  }
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <Typography className={classes.label}>
                  <PersonIcon color="primary" />
                  Transporter Official Name{" "}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className={classes.modernTextField}
                  fullWidth
                  id="vendor-modal-officialName"
                  type="text"
                  variant="outlined"
                  placeholder="Enter Official Name"
                  value={vendorFormData.officialName}
                  error={!!vendorErrors.officialName}
                  helperText={vendorErrors.officialName || ""}
                  onChange={(e) =>
                    handleVendorFormChange("officialName", e.target.value)
                  }
                />
              </div>
            </Grid>
          </Grid>

          <div style={{ marginTop: 16 }}>
            <Typography className="ml-1 pt-1" gutterBottom variant="h6">
              <span className="fontbold">
                <CarIcon color="primary" style={{ marginRight: 8 }} />
                Assign Vehicles
              </span>
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Autocomplete
                  multiple
                  id="vendor-modal-vehicle-selector"
                  limitTags={2}
                  getOptionLabel={(vehicle) => vehicle.number}
                  className={classes.modernAutocomplete}
                  options={modalVehicleList}
                  filterSelectedOptions
                  disablePortal={true}
                  getOptionSelected={(option, value) =>
                    option.number === value.number
                  }
                  value={modalMultiVehicles}
                  disableClearable
                  onChange={(event, newValue) =>
                    setModalMultiVehicles(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="dense"
                      placeholder="Select Vehicles"
                    />
                  )}
                />
              </Grid>
            </Grid>

            {modalMultiVehicles?.length > 0 && (
              <Box
                style={{
                  background:
                    "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                  border: "1px solid #bae6fd",
                  borderRadius: "16px",
                  padding: "16px",
                  margin: "16px 0",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{
                    marginBottom: 12,
                    color: "#0369a1",
                    fontWeight: 600,
                  }}
                >
                  Selected Vehicles ({modalMultiVehicles.length})
                </Typography>
                {modalMultiVehicles.map((module) => (
                  <Chip
                    key={module.number}
                    label={module.number}
                    size="small"
                    variant="outlined"
                    onDelete={() => {
                      setModalMultiVehicles(
                        modalMultiVehicles.filter(
                          (item) => item.number !== module.number,
                        ),
                      );
                    }}
                    style={{
                      margin: "4px",
                      borderColor: "#667eea",
                      color: "#667eea",
                      fontSize: "0.75rem",
                      fontWeight: 500,
                      borderRadius: 20,
                    }}
                  />
                ))}
              </Box>
            )}
          </div>
        </DialogContent>

        <DialogActions
          style={{
            padding: 15,
            borderTop: "1px solid rgba(102, 126, 234, 0.1)",
            background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
          }}
        >
          <Button
            onClick={handleVendorModalClose}
            className={`${classes.dialogButton} ${classes.cancelButton}`}
          >
            Cancel
          </Button>
          <Button
            onClick={handleVendorSubmit}
            disabled={vendorLoading}
            className={`${classes.dialogButton} ${classes.submitButton}`}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            {vendorLoading ? (
              <CircularProgress size={20} style={{ color: "#fff" }} />
            ) : (
              "Add Transporter"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
